import React from 'react';
import { Link } from 'react-router-dom';

// Os dois relatórios de datas, um ao lado do outro: a conta da Equatorial e o boleto que o
// VigorHub emite. Rotas próprias, para o link de cada um poder ser mandado direto.
const ABAS = [
  { chave: 'faturas', rotulo: 'Faturas da Equatorial', para: '/gestao/datas-faturas' },
  { chave: 'boletos', rotulo: 'Boletos da Vigor', para: '/gestao/datas-faturas/boletos' },
] as const;

const AbasDatas: React.FC<{ atual: (typeof ABAS)[number]['chave'] }> = ({ atual }) => (
  <nav className="inline-flex rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-0.5" aria-label="Relatórios de datas">
    {ABAS.map((a) => (
      <Link
        key={a.chave}
        to={a.para}
        aria-current={a.chave === atual ? 'page' : undefined}
        className={`px-3 py-1.5 text-xs font-semibold rounded-[10px] whitespace-nowrap transition-colors ${a.chave === atual ? 'bg-primary text-white' : 'text-gray-500 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-100'}`}
      >
        {a.rotulo}
      </Link>
    ))}
  </nav>
);

export default AbasDatas;
